import { adminRecords } from "./adminRecords";
import dateFormat from "dateformat";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "../models/Card";
import Utils from "./../Utils";

// eslint-disable-next-line
export default ({ data, user }) => {
  const [sessionEvents, setSessionEvents] = useState(null);

  useEffect(() => {
    const sessionId = data.get("sessionId");

    if (sessionId) {
      adminRecords.collection("sessionEvents")
        .where("sessionId", "==", sessionId)
        .orderBy("createdAt", "asc")
        .get()
        .then((result) => {
          if (result.docs) {
            setSessionEvents(result.docs);
          }
        });
    }
  }, []);

  let content = data.get("content");
  // cast to object if content is a string, to prevent char-wise splitting in loop below
  // future: consider parsing as JSON to make separate cards
  content = typeof content === "string" ? { 0: content } : content;
  let out = [];

  let i = 0;

  for (const [key, value] of Object.entries(content)) {
    if (value.split) {
      out.push(
        <div
          key={i}
          className="card"
        >
          <h4>{i + 1}</h4>
          <div>{Utils.nl2br(value)}</div>
        </div>
      );
    } else if (value.text) {
      // it's rewrite
      out.push(
        <div
          key={i}
          className="card"
        >
          <h4>{value.modifier}</h4>
          <div>{Utils.nl2br(value.text)}</div>
        </div>
      );
    } else {
      // it's an object with headings
      out.push(
        <div
          key={i}
          className="card"
        >
          <h4>{key}</h4>
          {value.join && <div>{Utils.nl2br(value.join("\n\n"))}</div>}
          {!value.join &&
            Object.keys(value).map((subKey, index) => {
              return (
                <div key={`${i}-${index}`}>
                  <h4>{subKey}</h4>
                  {value[subKey].map((c, cIndex) => (
                    <div key={`${i}-${index}-${cIndex}`}>
                      {Utils.nl2br(c)}
                      <br />
                      <br />
                    </div>
                  ))}
                </div>
              );
            })}
        </div>
      );
    }

    i += 1;
  }

  let passage;

  if (data.get("passage")) {
    passage = (
      <div className="section">
        <h3>Passage</h3>
        <div className="card">{Utils.nl2br(data.get("passage"))}</div>
      </div>
    );
  }

  const completions = data.get("completionId");
  let completionsContent;
  const invocationId = data.get("invocationId");

  if (Array.isArray(completions)) {
    completionsContent = completions.map((completion, index) => (
      <div key={`completion-${index}`}>
        <Link
          to={`/admin/completion/${completion}`}
          className="completion-link"
        >
          {completion}
        </Link>
      </div>
    ));
  } else {
    completionsContent = (
      <Link
        to={`/admin/completion/${completions}`}
        className="completion-link"
      >
        {completions}
      </Link>
    );
  }

  return (
    <div className="card-set">
      <div className="card-set-header">
        <h1>{Card.name(data.get("source"))}</h1>

        <div className="metadata">
          <small>ID: {data.id}</small>

          <small>
            Created on{" "}
            <Link
              to={`/admin/card-set/${data.id}`}
              className="date-link hover:underline"
            >
              {dateFormat(data.get("createdAt").toDate(), "mm/dd/yyyy hh:MM:ss")}
            </Link>
          </small>

          <small>
            In document{" "}
            <Link
              to={`/admin/document/${data.get("documentId")}`}
              className="document-link hover:underline"
            >
              {data.get("documentId")}
            </Link>
          </small>

          <small>
            GPT Completion
            <div className="completions">{completionsContent}</div>
          </small>
          {invocationId && (
            <small>
              Invocation{" "}
              <Link
                to={`/admin/invocation/${invocationId}`}
                className="hover:underline text-app-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                {invocationId}
              </Link>
            </small>
          )}

          {user && (
            <small>
              By{" "}
              <Link
                to={`/admin/user/${user.email}`}
                className="user-link"
              >
                {user.email}
              </Link>
            </small>
          )}
        </div>
      </div>

      <div className="section">
        <h3>Prompt</h3>
        <div className="card">{Utils.nl2br(data.get(Card.summaryKey(data.get("source"))) || "")}</div>
      </div>

      {sessionEvents && (
        <div className="section">
          <h3>Guidance Events</h3>
          <div className="card">
            <ul>
              {sessionEvents.map((event, index) => {
                return (
                  <li key={`event-${index}`}>
                    <strong>{event.get("name")}</strong>
                    {event.get("content") && (
                      <>
                        <br />
                        {Utils.nl2br(event.get("content"))}
                      </>
                    )}
                    {event.get("completionId") && (
                      <div>
                        <Link
                          to={`/admin/completion/${event.get("completionId")}`}
                          className="completion-link"
                        >
                          Completion {event.get("completionId")}
                        </Link>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}

      {passage}

      {data.get("guidance") && (
        <div className="section">
          <h3>Guidance</h3>
          <div className="card">{Utils.nl2br(data.get("guidance"))}</div>
        </div>
      )}

      <div className="section">
        <h3>Content</h3>
        <div className="content-cards">{out}</div>
      </div>
    </div>
  );
};
